<template>
    <ResponsiveImage :image-url="lenderLogo" width="100%" />
</template>

<script>
    import { providerState } from "@/state"
    import Providers from "@/model/provider/Providers"
    import DynamicProviderKey from "@/model/provider/DynamicProviderKey"

    export default {
        name: "PaymentPlanImage",
        props: {
            providerKey: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                componentType: "paymentPlanImage",
            }
        },

        computed: {
            lenderLogo() {
                const provider = Providers[DynamicProviderKey.extractProviderKey(this.providerKey)]
                const response = providerState.getPreAuthResponse(this.providerKey)
                const offerProviderId = response?.offeredProviderId
                if (offerProviderId && offerProviderId !== provider.providerId && provider.subLenders) {
                    const subLender = provider.subLenders.find(subLender => subLender.providerId === offerProviderId)
                    if (subLender) {
                        return subLender.logo
                    }
                }
                return provider?.logo
            },
        },
    }
</script>
